export default __webpack_public_path__ + "static/media/Monocal-D-Pot-ban.f05efb5a.jpg";